import {
  ALL_MCP_SCOPES,
  MCP_SCOPES,
  TEAM_MCP_SCOPES,
  WORKSPACE_MCP_SCOPES,
} from "../../supabase/functions/_shared/mcp/registry";

export { ALL_MCP_SCOPES };
export {
  isAllowedRedirect,
  isAllowedRedirectTarget,
  redirectTargetOf,
} from "../../supabase/functions/_shared/mcp/redirects";

const CONSENT_RETURN = /^\/oauth\/consent(\?[A-Za-z0-9._~%&=+-]*)?$/;

export function consentReturnPath(next: string | null): string | null {
  return next && CONSENT_RETURN.test(next) ? next : null;
}

export interface ScopeCopy {
  label: string;
  description: string;
}

export const MCP_SCOPE_COPY: Record<string, ScopeCopy> = {
  [MCP_SCOPES.clientsRead]: {
    label: "Ver clientes",
    description: "Consultar las organizaciones cliente, su plan y el estado de su suscripción.",
  },
  [MCP_SCOPES.billingRead]: {
    label: "Ver facturación",
    description: "Consultar cobros, pagos y periodos de facturación.",
  },
  [MCP_SCOPES.clientsWrite]: {
    label: "Modificar clientes",
    description: "Crear o cambiar datos de las organizaciones cliente.",
  },
  [MCP_SCOPES.assistantsRead]: {
    label: "Ver asistentes",
    description: "Consultar los asistentes de tu organización: sus instrucciones, su conocimiento y sus herramientas.",
  },
  [MCP_SCOPES.assistantsWrite]: {
    label: "Crear y modificar asistentes",
    description:
      "Crear asistentes, cambiar sus instrucciones, conocimiento y herramientas de captura de datos, activarlos o desactivarlos y probarlos con conversaciones simuladas. Antes de cada cambio te mostrará un resumen y te pedirá confirmarlo en el chat.",
  },
};

export const DEFAULT_GRANTED_SCOPES: string[] = [MCP_SCOPES.clientsRead];

export function scopesOfferedTo(isSuperAdmin: boolean): string[] {
  return isSuperAdmin ? [...TEAM_MCP_SCOPES, ...WORKSPACE_MCP_SCOPES] : [...WORKSPACE_MCP_SCOPES];
}

export function defaultScopesFor(isSuperAdmin: boolean): string[] {
  return isSuperAdmin ? DEFAULT_GRANTED_SCOPES : [MCP_SCOPES.assistantsRead];
}
